import { Dispatch, ReactElement, SetStateAction, useCallback, useState } from "react";
import { Image } from "primereact/image";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";


import { Order,  RequestFormType, TermsOfRequestType } from "../types";
import fexdexLogo from "../../../../assets/images/fedex-logo.png";

type PropTypes = {
    orders: Order[];
    formData: RequestFormType;
    termsOfRequest: TermsOfRequestType;
    setTermsOfRequest: Dispatch<SetStateAction<TermsOfRequestType>>
};


function OrderSummary(props: PropTypes): ReactElement {

    const {
        orders,
        formData,
        termsOfRequest,
        setTermsOfRequest
    } = props;

    const [includedDocuments] = useState(() => {
        return orders.map(order => {
            const { companyName, orderNumber, documentsAvailable } = order;
            return {
                companyName,
                orderNumber,
                fileCount: documentsAvailable.length
            }
        })
    })

    const handleAcceptRequest = useCallback((e: CheckboxChangeEvent) => {

        setTermsOfRequest(prev => {
            return {
                ...prev,
                [e.target.name]: e.checked
            }
        })
    }, [termsOfRequest]);

    return (
        <div className="flex flex-column gap-4">
            <div className="flex flex-column gap-3 p-3 p-card p-component">
                <div className="font-bold text-lg text-color">
                    <i className="pi pi-box mr-2" />Order Summary
                </div>
                <div className="border-top-1 surface-border py-3">
                    <div className="font-bold text-base text-color">
                        Included Physical Copies:
                    </div>
                    <div className="flex flex-column gap-2 px-2 mt-2">
                        {
                            includedDocuments.map(document => {
                                return (
                                    <div className="mi-1" key={document.orderNumber}>
                                        <span className="font-bold text-base text-color mr-1">
                                            {document.orderNumber}
                                        </span>
                                        -
                                        <span className="font-normal text-base text-color mx-1">
                                            {document.fileCount}
                                        </span>
                                        document(s)
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="flex justify-content-between align-items-center border-top-1 surface-border py-3">
                    <span className="font-medium text-lg text-color">
                        Ships via 
                        <Image className="mx-2" src={fexdexLogo} alt="FedEx" width="44" preview={false} />
                        2Day
                    </span>
                    <span className="text-lg text-color">
                        <span className="font-semibold mr-1">Total:</span>
                        <span className="font-bold ml-1">$49.95</span>
                    </span>
                </div>
            </div>
            <div className="flex flex-column gap-3 p-3 p-card p-component">
                <div className="font-bold text-lg text-color">
                    <i className="pi pi-envelope mr-2" />
                    Shipping Address
                </div>
                <div className="flex-1 border-top-1 surface-border py-3">
                    <div className="flex flex-column gap-2 px-2 mt-2">
                        <ul className="list-none font-normal text-base text-color">
                            <li className="py-1">
                                {formData.fullName}
                            </li>
                            <li className="py-1">
                                {formData.deliveryAddress.addressLine1}
                            </li>
                            {
                                formData.deliveryAddress.addressLine2 ? (
                                    <li className="py-1">
                                        {formData.deliveryAddress.addressLine2}
                                    </li>
                                ) : null
                            }
                            <li className="py-1">
                                {
                                    (() => {
                                        const { city, state, zipCode } = formData.deliveryAddress;
                                        return [city, `${state} ${zipCode}`].filter(Boolean).join(', ');
                                    })()
                                }
                            </li>
                            <li className="py-1">
                                United States
                            </li>
                            <li className="py-1 mt-2">
                                <span className="font-bold text-base text-color mr-1">
                                    Phone Number:
                                </span>
                                {formData.deliveryAddress.phoneNumber}
                            </li>
                            <li className="py-1">
                                <span className="font-bold text-base text-color mr-1">
                                    Address Type:
                                </span>
                                {formData.deliveryAddress.addressType === "BUSINESS" ? "Non-residential" :"Residential"}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="flex flex-column gap-3">
                <div className="flex align-items-center">
                    <Checkbox inputId="acknowledge" name="acknowledge" onChange={handleAcceptRequest} checked={termsOfRequest.acknowledge} />
                    <label htmlFor="acknowledge" className="ml-2">
                        I acknowledge that a signature is required upon delivery.
                    </label>
                </div>
                <div className="flex align-items-center">
                    <Checkbox inputId="accept" name="accept" onChange={handleAcceptRequest} checked={termsOfRequest.accept} />
                    <label htmlFor="accept" className="ml-2">
                        I have read and agree to the Terms for Requesting Physical Copies.
                    </label>
                </div>
            </div>
        </div>
    )
}


export default OrderSummary;